export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.98b875350d96d870079f7d0bb8dcffc4.css";